export class AddressUtil {
    static isValidEmail(email: string | undefined) {
        return !!email && /(.+)@(.+)\.(.+)/.test(email);
    }
}